<template>
	<inertia-head title="Home" />
	<ContentSlot ref="contentSlot" :errors="errors" :flash="flash"/>	

	<modal ref="confirmDeletePostModal" :hide_close="true">
		<template #title>Delete Post?</template>
		<template #body>
			<p>Are you sure you want to delete your post? You can't undo this process.</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formPost.processing" @click="confirmDeletePostModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formPost.processing" @click="deletePost()" class="btn btn-alt-success">
				<div
					v-if="formPost.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>


	<modal ref="confirmDeletePostCommentModal" :hide_close="true">
		<template #title>Delete Comment?</template>
		<template #body>
			<p>Are you sure you want to delete your comment? You can't undo this process.</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formComment.processing" @click="confirmDeletePostCommentModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formComment.processing" @click="deletePostComment()" class="btn btn-alt-success">
				<div
					v-if="formComment.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>

	<modal ref="confirmSpamPostCommentModal" :hide_close="true">
		<template #title>Mark as Spam?</template>
		<template #body>
			<p>Are you sure you want to report as spam comment? You can't undo this process.</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formPost.processing" @click="confirmSpamPostCommentModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formPost.processing" @click="spamPostComment()" class="btn btn-alt-success">
				<div
					v-if="formComment.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>


	<modal ref="confirmLockUnlockPostModal" :hide_close="true">
		<template #title>{{formPost.lock_post==1 ? 'Lock' : 'Unlock'}} Post?</template>
		<template #body>
			<p>Are you sure you want to {{formPost.lock_post==1 ? 'lock' : 'unlock'}} the post?</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formPost.processing" @click="confirmLockUnlockPostModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formPost.processing" @click="lockUnlockPost()" class="btn btn-alt-success">
				<div
					v-if="formPost.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>

	<modal ref="confirmLockUnlockPostCommentModal" :hide_close="true">
		<template #title>{{formPost.lock_comment==1 ? 'Lock' : 'Unlock'}} Post Comment?</template>
		<template #body>
			<p>Are you sure you want to {{formPost.lock_comment==1 ? 'lock' : 'unlock'}} the comment section?</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formPost.processing" @click="confirmLockUnlockPostCommentModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formPost.processing" @click="lockUnlockPostComment()" class="btn btn-alt-success">
				<div
					v-if="formPost.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>


	<modal ref="confirmLockUnlockCommentModal" :hide_close="true">
		<template #title>{{formComment.lock_comment==1 ? 'Lock' : 'Unlock'}} Comment?</template>
		<template #body>
			<p>Are you sure you want to {{formComment.lock_comment==1 ? 'lock' : 'unlock'}} the comment?</p>
		</template>
		<template #footer>
			<button type="button" :disabled="formComment.processing" @click="confirmLockUnlockCommentModal.toggleModal" class="btn btn-alt-secondary me-2">No</button>
			<button type="button" :disabled="formComment.processing" @click="lockUnlockComment()" class="btn btn-alt-success">
				<div
					v-if="formComment.processing"
					class="spinner-border spinner-border-sm text-black me-1"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
				Yes
			</button>
		</template>
	</modal>

	<modal ref="reportModal" :hide_close="true">
		<template #title>Submit a report</template>
		<template #body>
			<p>Thanks for looking out for yourself and your fellow community by reporting things that break the rules. Let us know what's happening, and we'll look into it.</p>
			<div>
				<button type="button" @click="formReport.report_type='Harassment'" class="btn btn-sm btn-outline-secondary rounded-pill mb-3 me-3" :class="{'active':formReport.report_type=='Harassment'}">Harassment</button>
				<button type="button" @click="formReport.report_type='Threatening violence'" class="btn btn-sm btn-outline-secondary rounded-pill mb-3 me-3" :class="{'active':formReport.report_type=='Threatening violence'}">Threatening violence</button>
				<button type="button" @click="formReport.report_type='Hate'" class="btn btn-sm btn-outline-secondary rounded-pill mb-3 me-3" :class="{'active':formReport.report_type=='Hate'}">Hate</button>
				<button type="button" @click="formReport.report_type='Minor abuse or sexualization'" class="btn btn-sm btn-outline-secondary rounded-pill mb-3 me-3" :class="{'active':formReport.report_type=='Minor abuse or sexualization'}">Minor abuse or sexualization</button>
				<button type="button" @click="formReport.report_type='Sharing personal information'" class="btn btn-sm btn-outline-secondary rounded-pill mb-3 me-3" :class="{'active':formReport.report_type=='Sharing personal information'}">Sharing personal information</button>
				<button type="button" @click="formReport.report_type='Self-harm or suicide'" class="btn btn-sm btn-outline-secondary rounded-pill mb-3 me-3" :class="{'active':formReport.report_type=='Self-harm or suicide'}">Self-harm or suicide</button>
				<button type="button" @click="formReport.report_type='Spam'" class="btn btn-sm btn-outline-secondary rounded-pill mb-3 me-3" :class="{'active':formReport.report_type=='Spam'}">Spam</button>
				<button type="button" @click="formReport.report_type='Report abuse'" class="btn btn-sm btn-outline-secondary rounded-pill mb-3 me-3" :class="{'active':formReport.report_type=='Report abuse'}">Report abuse</button>
			</div>
			<div class="block block-rounded bg-gray-light mt-2">
				<div class="block-content p-2">
					<i class="fa fa-exclamation-circle me-1"></i> Not sure if something is breaking the rules? Review the <a href="javascript:void(0)" class="standard-link text-info">TRC Community Rules</a>
				</div>
			</div>
			<div class="mt-3">
				<div v-if="formReport.report_type=='Harassment'">
					<p class="fw-bold mb-2">{{formReport.report_type}}</p>
					<p>Harassing, bullying, intimidating, sexualizing, or abusing an individual or group of people with the result of discouraging them from participating.</p>
				</div>
				<div v-if="formReport.report_type=='Threatening violence'">
					<p class="fw-bold mb-2">{{formReport.report_type}}</p>
					<p>Encouraging, glorifying, or inciting violence or physical harm against individuals or groups of people, places, or animals.</p>
				</div>
				<div v-if="formReport.report_type=='Hate'">
					<p class="fw-bold mb-2">{{formReport.report_type}}</p>
					<p>Promoting hate or inciting violence based on identity or vulnerability.</p>
				</div>
				<div v-if="formReport.report_type=='Minor abuse or sexualization'">
					<p class="fw-bold mb-2">{{formReport.report_type}}</p>
					<p>Sharing or soliciting content involving abuse, neglect, or sexualization of minors or any predatory or inappropriate behavior involving minors.</p>
				</div>
				<div v-if="formReport.report_type=='Sharing personal information'">
					<p class="fw-bold mb-2">{{formReport.report_type}}</p>
					<p>Sharing or threatening to share private, personal, or confidential information about someone.</p>
				</div>
				<div v-if="formReport.report_type=='Self-harm or suicide'">
					<p class="fw-bold mb-2">{{formReport.report_type}}</p>
					<p>Behavior or comments that make you think someone may be considering suicide or seriously hurting themselves.</p>
				</div>
				<div v-if="formReport.report_type=='Spam'">
					<p class="fw-bold mb-2">{{formReport.report_type}}</p>
					<p>Repeated, unwanted, or unsolicited manual or automated actions that negatively affect redditors, communities, and the Reddit platform.</p>
				</div>
				<div v-if="formReport.report_type=='Report abuse'">
					<p class="fw-bold mb-2">{{formReport.report_type}}</p>
					<p>Using Reddit’s reporting tools to spam, harass, bully, intimidate, abuse, or create a hostile environment.</p>
				</div>
			</div>
		</template>
		<template #footer>
			<button type="button" @click="reportModal.toggleModal" class="btn btn-alt-secondary me-2">Cancel</button>
			<button type="button" class="btn btn-alt-success">Report</button>
		</template>
	</modal>



	<div class="content">
		<div v-if="community!=null" class="row g-xxl-5 items-push">
			<div class="col-lg-8 mb-6">
				<div v-if="['Private'].includes(community.status) && ['Join','Requesting'].includes(community.join_status)" class="block block-rounded">
					<div class="block-content block-content-full text-center">
						<h1 class="display-6 fw-bold text-info">
					        <i class="fa fa-flag me-1 opacity-50"></i>
					        <span>Community Post</span>
				     	</h1>
				     	<div v-if="community.join_status=='Join'">
					      	<h3 class="fw-bold mt-5 mb-2">Unauthorized to view the post...</h3>
					      	<h4 class="fw-medium text-muted mb-0">This community is a {{community.status}}.</h4>
					      	<p class="h4 mt-5">Request access to contribute on this post.</p>
					      	<button type="button" :disabled="formJoinCommunity.processing" @click="joinCommunity()" class="btn btn-outline-info">
					      		<div
									v-if="formJoinCommunity.processing"
									class="spinner-border spinner-border-sm text-info me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
					      		<i v-else class="fa me-1 fa-lock me-1"></i>
						      	Requesting to join
				     	 	</button>
			     	 	</div>
			     	 	<div v-else>
			     	 		<p class="h4 mt-5">Your request is still being processed. Please allow 1–2 days for approval.</p>
			     	 	</div>
					</div>
				</div>
				<div v-else class="block block-rounded">
					<div class="block-header">
						<div class="block-title">
							<div class="nav-main-horizontal fw-semibold mb-0">
								<span class="nav-main-item me-2">
									<inertia-link :href="'/member/community/c/'+community.community_name" class="btn btn-sm btn-outline-secondary rounded-pill mt-1"><i class="fa fa-arrow-left"></i></inertia-link>
								</span>
								<span class="nav-main-item">
									<img
										class="img-avatar img-avatar32 me-1 user-avatar img-avatar-thumb"
										:src="community.icon_logo"
									/>
								</span>
								<span class="nav-main-item">
									<span class="nav-main-horizontal nav-main-hover">
										<span class="nav-main-item">
											<inertia-link data-bs-toggle="submenu" aria-haspopup="true" aria-expanded="false" :href="'/member/community/c/'+community.community_name" class="text-black standard-link me-1">c/{{community.community_name}}</inertia-link> 
											<div class="nav-main-submenu bg-white block block-rounded shadow">
												<div class="block-header p-0 px-3 pt-2">
													<div class="block-title">
														<p class="fw-bold m-0">{{community.community_name}}</p>
													</div>
												</div>
												<div class="block-content p-3 pt-0">
													<div class="dropdown-divider"></div>
													<div class="row fs-xs">
														<div class="col">
															<div>{{community.member_total}}</div>
															<span>Member</span>	
														</div>
														<div class="col">
															<div>{{community.visit_total}}</div>
															<span>Views</span>
														</div>
													</div>
												</div>
											</div>
										</span>
										<span class="nav-main-item">
											<span class="fs-xs text-muted ms-2">{{post ? post.posted_at : ''}}</span>
										</span>
									</span>
									<div v-if="post!=null" class="nav-main-horizontal comment-header-member" :class="{'nav-main-hover':post.post_status!='Removed'}">
										<div>
											<div v-if="post.post_status=='Removed'">
												<span class="fs-xs fw-bold text-muted">[DELETED]</span>
											</div>
											<div v-else class="nav-main-item">
												<inertia-link data-bs-toggle="submenu" aria-haspopup="true" aria-expanded="false" :href="'/member/community/m/'+post.member_info.member_name" class="fs-xs text-muted standard-link">{{post.member_info.member_name}}</inertia-link> 
												<div class="nav-main-submenu bg-white block block-rounded shadow">
													<div class="block-header p-0 px-3 pt-2">
														<div class="block-title">
															<p class="fw-bold m-0">{{post.member_info.member_name}}</p>
															<div class="text-muted fs-xs">m/{{post.member_info.member_name}}</div>
															<div class="text-muted fs-xs"><i class="fa fa-calendar me-1"></i>{{post.member_info.dateregs}}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</span>
							</div>
						</div>
						<div class="block-options">
							<button v-if="community.status!='Public' && community.join_status!='Joined'" @click="joinCommunity()" type="button" class="btn btn-sm rounded-pill px-2 me-1" 
								:class="{'btn-alt-warning':community.join_status=='Requesting','btn-alt-info':community.join_status=='Join'}"
							>
								<div
									v-if="formJoinCommunity.processing && formJoinCommunity.community_uuid==community.community_uuid"
									class="spinner-border spinner-border-sm text-dark me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								{{community.join_status}}
							</button>
							<span v-if="post!=null" class="btn-block-option">
								<div v-if="post.post_status!='Removed'">
									<button type="button" id="post_option_dropdown" class="btn rounded-pill btn-xs btn-alt-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">...</button>
					            	<div class="dropdown-menu" aria-labelledby="post_option_dropdown" data-popper-placement="bottom-start">
					            		<div v-if="user.member_uuid==post.member_uuid">
						            		<a v-if="post.lock_post==1 || post.is_spam==1" type="button" disabled="true" class="dropdown-item disabled" href="javascript:void(0)"><i class="fa fa-edit me-1"></i>Edit Post</a>
						            		<a v-else type="button" @click="post.is_edit=1" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-edit me-1"></i>Edit Post</a>
						            		<a type="button" @click="confirmDeletePost()" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash me-1"></i>Delete Post</a>
					            		</div>
					            		<div v-else>
					            			<a type="button" @click="reportPost()" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-flag me-1"></i>Report</a>
					            		</div>
					            		<div v-if="user.member_uuid==community.member_uuid">
					            			<a v-if="user.member_uuid!=post.member_uuid" type="button" @click="confirmDeletePost()" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash me-1"></i>Remove Post</a>
					            			<a type="button" @click="confirmLockUnlockPost(post.lock_post)" class="dropdown-item" href="javascript:void(0)"><i class="fa me-1" :class="{'fa-lock':post.lock_post==0,'fa-unlock':post.lock_post==1}"></i>{{post.lock_post==1 ? 'Unlock' : 'Lock'}} Post</a>
						            		<a type="button" @click="confirmLockUnlockPostComment(post.lock_comment)" class="dropdown-item" href="javascript:void(0)"><i class="fa me-1" :class="{'fa-lock':post.lock_comment==0,'fa-unlock':post.lock_comment==1}"></i>{{post.lock_comment==1 ? 'Unlock' : 'Lock'}} Post Comment</a>
					            		</div>
					            	</div>
				            	</div>
			            	</span>
						</div>
					</div>
					<div v-if="post!=null" class="block">
						<div class="block-content block-content-full pt-0">
							<div>
								<span v-if="(post.post_status=='Removed' || post.lock_post==1 || post.is_spam==1) && (community.member_uuid==user.community_uuid || post.member_uuid==user.member_uuid)" class="badge bg-danger mb-3">{{post.post_status=='Removed' ? 'Deleted' : post.lock_post==1 ? 'Locked' : post.is_spam==1 ? 'Spam' : '' }}</span>
								<h5 :class="{'text-muted':post.post_status=='Removed' || post.lock_post==1 || post.is_spam==1}">{{post.title}}</h5>
							</div>
							<div v-if="post.is_edit==1" class="my-4">
								<form id="commentareaform" class="form-control block block-rounded mb-0" :class="{'border-danger':post.is_edit==1 && formPost.is_error && (formPost.title==null || formPost.title.length<=10)}">
									<div class="block m-0">
										<div class="block-content p-1">
											<textarea v-model="formPost.title" id="comment-textarea" name="comment-textarea" class="comment-textarea"></textarea>
											<div class="m-1">
												<div class="text-end">
													<button @click="post.is_edit=0,formPost.title=''" type="button" :disabled="formPost.processing" class="btn btn-xs btn-outline-secondary me-1">Cancel</button>
													<button @click="updatePost()" type="button" :disabled="formPost.processing" class="btn btn-xs btn-info">
														<div
															v-if="formPost.processing"
															class="spinner-border spinner-border-sm text-white me-1"
															role="status"
														>
															<span class="sr-only">Loading...</span>
														</div>
														Save
													</button>
												</div>
											</div>
										</div>
									</div>
								</form>
								<div v-if="post.is_edit==1 && formPost.is_error && (formPost.title==null || formPost.title.length<=10)" class="text-danger">{{formPost.error_msg}}</div>
							</div>
							<div class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="post.description"></div>

				            <div class="pt-5">
					            <div v-if="post.lock_comment==1">
					            	<span class="p-0 me-3">
					            		<button type="button" disabled class="btn btn-xs btn-outline-warning rounded-pill disabled">
											<i class="fa fa-arrow-up"></i>
					            		</button>
					            		<span class="px-1">{{post.vote_total}}</span>
					            		<button disabled type="button" class="btn btn-xs btn-outline-danger rounded-pill disabled">
											<i class="fa fa-arrow-down"></i>
					            		</button>	
					            	</span>
					            	<span>
					            		<button disabled type="button" class="btn btn-xs btn-alt-secondary rounded-pill disabled"><label for="comment-textarea" class="cursor-pointer"><i class="fa fa-comment me-1"></i>{{post.comment_total}} {{post.comment_total>0?'Comments':'Comment'}}</label></button>
					            	</span>
					            </div>
					            <div v-else>
					            	<span class="p-0 me-3">
					            		<button @click="votePostComment(null,'like',post.vote,null)" :disabled="formVotePostComment.processing && formVotePostComment.post_uuid==post.post_uuid && formVotePostComment.comment_uuid==null" type="button" class="btn btn-xs btn-outline-warning rounded-pill" :class="{'active':post.vote==1}">
					            			<div
												v-if="formVotePostComment.processing && formVotePostComment.post_uuid==post.post_uuid && formVotePostComment.comment_uuid==null && formVotePostComment.vote_label=='like'"
												class="spinner-border spinner-border-sm text-warning"
												role="status"
											>
												<span class="sr-only">Loading...</span>
											</div>
											<i v-else class="fa fa-arrow-up"></i>
					            		</button>
					            		<span class="px-1">{{post.vote_total}}</span>
					            		<button @click="votePostComment(null,'dislike',post.vote,null)" :disabled="formVotePostComment.processing && formVotePostComment.post_uuid==post.post_uuid && formVotePostComment.comment_uuid==null" type="button" class="btn btn-xs btn-outline-danger rounded-pill" :class="{'active':post.vote<0}">
					            			<div
												v-if="formVotePostComment.processing && formVotePostComment.post_uuid==post.post_uuid && formVotePostComment.comment_uuid==null && formVotePostComment.vote_label=='dislike'"
												class="spinner-border spinner-border-sm text-danger"
												role="status"
											>
												<span class="sr-only">Loading...</span>
											</div>
											<i v-else class="fa fa-arrow-down"></i>
					            		</button>	
					            	</span>
					            	<span>
					            		<button @click="post.is_comment=1" type="button" class="btn btn-xs btn-alt-secondary rounded-pill"><label for="comment-textarea" class="cursor-pointer"><i class="fa fa-comment me-1"></i>{{post.comment_total}} {{post.comment_total>0?'Comments':'Comment'}}</label></button>
					            	</span>
					            </div>
				            </div>
						</div>
						<div class="block-content block-content-full">
							<div v-if="post.lock_post==0" class="my-4">
								<form id="commentareaform" class="form-control block block-rounded mb-0" :class="{'border-danger':post.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==null && (post.to_comment==null || post.to_comment.length<=10)}">
									<div class="block m-0">
										<div class="block-content p-1">
											<textarea @click="post.is_comment=1" v-model="post.to_comment" id="comment-textarea" name="comment-textarea" class="comment-textarea" placeholder="Join the conversation"></textarea>
											<div v-if="post.is_comment==1" class="m-1">
												<div class="text-end">
													<button @click="post.is_comment=0,post.to_comment=null,formComment.is_error=false" type="button" :disabled="formComment.processing" class="btn btn-xs btn-outline-secondary me-1">Cancel</button>
													<button @click="postComment(null,0,post.to_comment)" type="button" :disabled="formComment.processing" class="btn btn-xs btn-info">
														<div
															v-if="formComment.processing"
															class="spinner-border spinner-border-sm text-white me-1"
															role="status"
														>
															<span class="sr-only">Loading...</span>
														</div>
														Comment
													</button>
												</div>
											</div>
										</div>
									</div>
								</form>
								<div v-if="post.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==null && (post.to_comment==null || post.to_comment.length<=10)" class="text-danger">{{formComment.error_msg}}</div>
							</div>

							<div class="my-2">
								<div v-if="post.lock_comment==1 && community.member_uuid!=user.member_uuid">
									<p class="m-0 text-muted text-center fw-bold">{{post.lock_comment_message}}</p>
								</div>
								<div v-else class="comment-section">
									<span v-if="community.member_uuid==user.member_uuid && post.lock_comment==1" class="badge bg-danger mb-3">Locked Comment Section</span>
									<ul v-if="comments.length>0" class="list"><!--START main comments  -->
										<li v-for="(comment,cIndex) in comments" class="list-activity" :class="{'reply':comment.lock_comment==0 && comment.is_expand==1 && comment.replies.length>0,'last-reply':comment.lock_comment==1,'last-list':comments.length==(cIndex+1)}">
											<div class="block mb-2">
												<div class="block-header m-0 p-0">
													<div class="block-title mb-0">
														<span v-if="comment.is_expand==0" class="me-1">
															<button @click="comment.is_expand=1" type="button" class="btn btn-xs btn-outline-secondary rounded-pill show-reply">
																<i class="fa fa-plus fs-xs"></i>
															</button>
														</span>
														<span v-else class="me-1">
															<img 
																class="img-avatar img-avatar20 user-avatar img-avatar-thumb m-0"
																:src="comment.member_logo" :class="{'border border-secondary':comment.comment_status=='Removed'}"
															/>
														</span>
														<span v-if="comment.comment_status=='Removed' && comment.member_uuid!=user.member_uuid" class="fw-bold text-muted fs-xs">[deleted]</span>
														<inertia-link v-else :href="'/member/community/m/'+comment.comment_name" class="standard-link fw-semibold fs-xs text-black">{{comment.comment_name}}</inertia-link> 
														. <span class="fs-xs text-muted">{{comment.posted_at}}</span>
													</div>
												</div>
												<div v-if="comment.is_expand==1" class="block-content pt-0">
													<div>
														<div>
															<span v-if="(comment.comment_status=='Removed' || comment.lock_comment==1 || comment.is_spam==1) && (community.member_uuid==user.member_uuid || comment.member_uuid==user.member_uuid)" class="badge bg-danger">
																{{comment.comment_status=='Removed' ? 'Deleted' : comment.lock_comment==1 ? 'Locked' : comment.is_spam==1 ? 'Spam' : 'Deleted' }}
															</span>
															<div class="fs-sm mt-2" :class="{'text-muted':comment.comment_status=='Removed' || comment.lock_comment==1 || comment.is_spam==1}" style="white-space: pre; white-space:break-spaces;" v-html="comment.comment"></div>
														</div>
														<div class="row pt-3">
															<div class="relative col-11">
																<div v-if="comment.lock_comment==0">
																	<button v-if="comment.replies.length>0" @click="comment.is_expand=0" type="button" class="btn btn-xs btn-outline-secondary rounded-pill hide-reply">
																		<i class="fa fa-minus fs-xs"></i>
																	</button>
																	<span>
														            	<span class="me-3">
														            		<button @click="votePostComment(comment.comment_uuid,'like',comment.vote,cIndex)" :disabled="formVotePostComment.processing && formVotePostComment.comment_uuid==comment.comment_uuid" type="button" class="btn btn-xs btn-outline-warning rounded-pill" :class="{'active':comment.vote==1}">
														            			<div
																					v-if="formVotePostComment.processing && formVotePostComment.comment_uuid==comment.comment_uuid && formVotePostComment.vote_label=='like'"
																					class="spinner-border spinner-border-sm text-warning"
																					role="status"
																				>
																					<span class="sr-only">Loading...</span>
																				</div>
																				<i v-else class="fa fa-arrow-up"></i>
														            		</button>
														            		<span class="px-1">{{comment.vote_total}}</span>
														            		<button @click="votePostComment(comment.comment_uuid,'dislike',comment.vote,cIndex)" :disabled="formVotePostComment.processing && formVotePostComment.comment_uuid==comment.comment_uuid" type="button" class="btn btn-xs btn-outline-danger rounded-pill" :class="{'active':comment.vote<0}">
														            			<div
																					v-if="formVotePostComment.processing && formVotePostComment.comment_uuid==comment.comment_uuid && formVotePostComment.vote_label=='dislike'"
																					class="spinner-border spinner-border-sm text-danger"
																					role="status"
																				>
																					<span class="sr-only">Loading...</span>
																				</div>
																				<i v-else class="fa fa-arrow-down"></i>
														            		</button>	
														            	</span>
														            	<button @click="comment.is_comment=1" type="button" class="btn rounded-pill btn-xs btn-alt-secondary me-3"><label for="comment-textarea0" class="cursor-pointer"><i class="fa fa-comment me-1"></i>Reply</label></button>
													            	</span>
													            	<span>
													            		<span v-if="comment.comment_status=='Removed' && user.member_uuid!=comment.member_uuid"></span>
													            		<span v-else>
													            			<!-- <button v-if="comment.insight==1" type="button" class="btn rounded-pill btn-xs btn-alt-secondary me-3"><i class="fa fa-chart-bar me-1"></i>Insights</button> -->
															            	<button type="button" :id="'comment_dropdown_'+cIndex" class="btn rounded-pill btn-xs btn-alt-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">...</button>
															            	<div class="dropdown-menu" :aria-labelledby="'comment_dropdown_'+cIndex" data-popper-placement="bottom-start">
															            		<div v-if="user.member_uuid==comment.member_uuid && comment.comment_status!='Removed'">
																            		<a v-if="comment.is_spam==0" type="button" @click="comment.is_edit=1,comment.is_comment=1,comment.to_comment=comment.comment" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-edit me-1"></i>Edit</a>
															            			<a type="button" @click="confirmDeletePostComment(comment.comment_uuid,cIndex)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash me-1"></i>Delete</a>
															            		</div>
															            		<div v-else>
															            			<a type="button" @click="reportPostComment(comment.comment_uuid)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-flag me-1"></i>Report</a>
															            		</div>
															            	</div>
													            		</span>
													            	</span>
													            	<span v-if="comment.comment_status=='Removed' && community.member_uuid==user.member_uuid" class="ms-3">
													            		<button type="button" class="btn btn-xs btn-outline-secondary">
													            			<span>Removed {{comment.removed_at}}</span>
													            		</button>
													            	</span>
												            	</div>
												            </div>
											            	<div v-if="user.member_uuid==community.member_uuid" class="col-1">
											            		<button type="button" :id="'settings_comment_dropdown_'+cIndex" class="btn btn-xs btn-outline-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i class="fa fa-cog"></i></button>
											            		<div class="dropdown-menu" :aria-labelledby="'settings_comment_dropdown_'+cIndex" data-popper-placement="bottom-start">
												            		<a v-if="comment.comment_status!='Removed' && user.member_uuid!=comment.member_uuid" type="button" @click="confirmRemovePostComment(comment.comment_uuid,comment.member_uuid,cIndex)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-times me-1"></i>Remove</a>
											            			<a v-if="comment.is_spam==0 && user.member_uuid!=comment.member_uuid" type="button" @click="confirmSpamPostComment(comment.comment_uuid,cIndex)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-calendar-times me-1"></i>Mark as Spam</a>
												            		<a type="button" @click="confirmLockUnlockComment(comment.comment_uuid,comment.lock_comment,cIndex)" class="dropdown-item" href="javascript:void(0)"><i class="fa me-1" :class="{'fa-lock':comment.lock_comment==0,'fa-unlock':comment.lock_comment==1}"></i>{{comment.lock_comment==1 ? 'Unlock' : 'Lock'}} Comment</a>
												            	</div>
											            	</div>
											            </div>
										            	<div v-if="comment.is_comment==1" class="my-2">
										            		<form id="commentareaform" class="form-control block block-rounded mb-0" :class="{'border-danger':comment.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==comment.comment_uuid && (comment.to_comment==null || comment.to_comment.length<=10)}">
											            		<textarea v-model="comment.to_comment" :readonly="formComment.processing" id="comment-textarea0" name="comment-textarea0" class="comment-textarea" placeholder="Join the conversation"></textarea>
																<div class="m-1">
																	<div class="text-end">
																		<button @click="comment.is_comment=0,comment.to_comment=null,comment.is_edit=0,formComment.is_error=false" type="button" :disabled="formComment.processing" class="btn btn-xs btn-outline-secondary me-1">Cancel</button>
																		<button @click="postComment(comment.comment_uuid,1,comment.to_comment,cIndex,comment.is_edit)" type="button" :disabled="formComment.processing" class="btn btn-xs btn-info">
																			<div
																				v-if="formComment.processing && formComment.from_comment_uuid==comment.comment_uuid"
																				class="spinner-border spinner-border-sm text-white me-1"
																				role="status"
																			>
																				<span class="sr-only">Loading...</span>
																			</div>
																			Comment
																		</button>
																	</div>
																</div>
															</form>
															<div v-if="comment.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==comment.comment_uuid && (comment.to_comment==null || comment.to_comment.length<=10)" class="text-danger">{{formComment.error_msg}}</div>
										            	</div>
										            </div>
												</div>
											</div>
											<ul v-if="comment.lock_comment==0 && comment.replies.length>0 && comment.is_expand==1" class="list ps-3"><!--START 1st level  -->
												<li v-for="(reply1,r1Index) in comment.replies" class="list-activity ms-3" :class="{'reply':reply1.lock_comment==0 && reply1.is_expand==1 && reply1.replies.length>0,'last-reply':(reply1.lock_comment==1 && comment.replies.length==0) || comment.replies.length==(r1Index+1)}">
													<div class="block mb-2">
														<div class="block-header m-0 p-0 reply-header">
															<div class="block-title">
																<span v-if="reply1.is_expand==0" class="me-1">
																	<button @click="reply1.is_expand=1" type="button" class="btn btn-xs btn-outline-secondary rounded-pill show-reply">
																		<i class="fa fa-plus fs-xs"></i>
																	</button>
																</span>
																<span v-else class="me-1">
																	<img
																		class="img-avatar img-avatar20 me-1 user-avatar img-avatar-thumb m-0" :class="{'border border-secondary':reply1.comment_status=='Removed'}"
																		:src="reply1.member_logo"
																	/>
																</span>
																<span v-if="reply1.comment_status=='Removed' && reply1.member_uuid!=user.member_uuid" class="fw-bold text-muted fs-xs">[deleted]</span>
																<inertia-link v-else :href="'/member/community/m/'+reply1.comment_name" class="standard-link fw-semibold fs-xs text-black">{{reply1.comment_name}}</inertia-link> 
																. <span class="fs-xs text-muted">{{reply1.posted_at}}</span>
															</div>
														</div>
														<div v-if="reply1.is_expand==1" class="block-content pt-0">
															<div>
																<span v-if="(reply1.comment_status=='Removed' || reply1.lock_comment==1 || reply1.is_spam==1) && (community.member_uuid==user.member_uuid || reply1.member_uuid==user.member_uuid)" class="badge bg-danger">
																	{{reply1.comment_status=='Removed' ? 'Deleted' : reply1.lock_comment==1 ? 'Locked' : reply1.is_spam==1 ? 'Spam' : 'Deleted' }}
																</span>
																<div class="fs-sm mt-2" :class="{'text-muted':reply1.comment_status=='Removed' || reply1.lock_comment==1 || reply1.is_spam==1}" style="white-space: pre; white-space:break-spaces;" v-html="reply1.comment"></div>
															</div>
															<div class="pt-3">
																<div class="row">
																	<div class="relative col-11">
																		<div v-if="reply1.lock_comment==0">
																			<button v-if="reply1.replies.length>0" @click="reply1.is_expand=0" type="button" class="btn btn-xs btn-outline-secondary rounded-pill hide-reply">
																				<i class="fa fa-minus fs-xs"></i>
																			</button>
																			<span>
																            	<span class="me-3">
																            		<button @click="votePostComment(reply1.comment_uuid,'like',reply1.vote,(cIndex+'-'+r1Index))" :disabled="formVotePostComment.processing && formVotePostComment.comment_uuid==reply1.comment_uuid" type="button" class="btn btn-xs btn-outline-warning rounded-pill" :class="{'active':reply1.vote==1}">
																            			<div
																							v-if="formVotePostComment.processing && formVotePostComment.comment_uuid==reply1.comment_uuid && formVotePostComment.vote_label=='like'"
																							class="spinner-border spinner-border-sm text-warning"
																							role="status"
																						>
																							<span class="sr-only">Loading...</span>
																						</div>
																						<i v-else class="fa fa-arrow-up"></i>	
															            			</button>
																            		<span class="px-1">{{reply1.vote_total}}</span>
																            		<button @click="votePostComment(reply1.comment_uuid,'dislike',reply1.vote,(cIndex+'-'+r1Index))" :disabled="formVotePostComment.processing && formVotePostComment.comment_uuid==reply1.comment_uuid" type="button" class="btn btn-xs btn-outline-danger rounded-pill" :class="{'active':reply1.vote<0}">
																            			<div
																							v-if="formVotePostComment.processing && formVotePostComment.comment_uuid==reply1.comment_uuid && formVotePostComment.vote_label=='dislike'"
																							class="spinner-border spinner-border-sm text-danger"
																							role="status"
																						>
																							<span class="sr-only">Loading...</span>
																						</div>
																						<i v-else class="fa fa-arrow-down"></i>
																            		</button>	
																            	</span>
																            	<button @click="reply1.is_comment=1" type="button" class="btn rounded-pill btn-xs btn-alt-secondary me-3"><label for="comment-textarea1" class="cursor-pointer"><i class="fa fa-comment me-1"></i>Reply</label></button>
															            	</span>
															            	<span>
															            		<span v-if="(comment.comment_status=='Removed' || reply1.comment_status=='Removed') && (reply1.comment_status=='Removed' && user.member_uuid!=reply1.member_uuid)"></span>
															            		<span v-else>
															            			<!-- <button v-if="reply1.insight==1" type="button" class="btn rounded-pill btn-xs btn-alt-secondary me-3"><i class="fa fa-chart-bar me-1"></i>Insights</button> -->
																	            	<button type="button" class="btn rounded-pill btn-xs btn-alt-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">...</button>
																	            	<div class="dropdown-menu" :aria-labelledby="'comment_dropdown_'+cIndex+'_'+r1Index" data-popper-placement="bottom-start">
																	            		<div v-if="user.member_uuid==reply1.member_uuid && reply1.comment_status!='Removed'">
																		            		<a v-if="reply1.is_spam==0" type="button" @click="reply1.is_edit=1,reply1.is_comment=1,reply1.to_comment=reply1.comment" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-edit me-1"></i>Edit</a>
																	            			<a type="button" @click="confirmDeletePostComment(reply1.comment_uuid,(cIndex+'-'+r1Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash me-1"></i>Delete</a>
																	            		</div>
																	            		<div v-else>
																	            			<a type="button" @click="reportPostComment(reply1.comment_uuid)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-flag me-1"></i>Report</a>
																	            		</div>
																	            	</div>
															            		</span>
															            	</span>
															            	<span v-if="reply1.comment_status=='Removed' && community.member_uuid==user.member_uuid" class="ms-3">
															            		<button type="button" class="btn btn-xs btn-outline-secondary">
															            			<span>Removed {{reply1.removed_at}}</span>
															            		</button>
															            	</span>
														            	</div>
														            </div>
													            	<div v-if="user.member_uuid==community.member_uuid" class="col-1">
													            		<button type="button" :id="'settings_comment_dropdown_'+cIndex+'_'+r1Index" class="btn btn-xs btn-outline-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i class="fa fa-cog"></i></button>
													            		<div class="dropdown-menu" :aria-labelledby="'settings_comment_dropdown_'+cIndex+'_'+r1Index" data-popper-placement="bottom-start">
														            		<a v-if="reply1.comment_status!='Removed' && user.member_uuid!=reply1.member_uuid" type="button" @click="confirmRemovePostComment(reply1.comment_uuid,reply1.member_uuid,(cIndex+'-'+r1Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-times me-1"></i>Remove</a>
													            			<a v-if="reply1.is_spam==0 && user.member_uuid!=reply1.member_uuid" type="button" @click="confirmSpamPostComment(reply1.comment_uuid,(cIndex+'-'+r1Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-calendar-times me-1"></i>Mark as Spam</a>
														            		<a type="button" @click="confirmLockUnlockComment(reply1.comment_uuid,reply1.lock_comment,(cIndex+'-'+r1Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-lock me-1" :class="{'fa-lock':reply1.lock_comment==0,'fa-unlock':reply1.lock_comment==1}"></i>{{reply1.lock_comment==1? 'Unlock':'Lock'}} Comment</a>
														            	</div>
													            	</div>
												            	</div>
												            	<div v-if="reply1.is_comment==1" class="my-2">
												            		<form id="commentareaform" class="form-control block block-rounded mb-0" :class="{'border-danger':reply1.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==reply1.comment_uuid && (reply1.to_comment==null || reply1.to_comment.length<=10)}">
													            		<textarea v-model="reply1.to_comment" :readonly="formComment.processing" id="comment-textarea1" name="comment-textarea1" class="comment-textarea" placeholder="Join the conversation"></textarea>
																		<div class="m-1">
																			<div class="text-end">
																				<button @click="reply1.is_comment=0,reply1.to_comment=null" type="button" :disabled="formComment.processing" class="btn btn-xs btn-outline-secondary me-1">Cancel</button>
																				<button @click="postComment(reply1.comment_uuid,2,reply1.to_comment,(cIndex+'-'+r1Index),reply1.is_edit)" type="button" :disabled="formComment.processing" class="btn btn-xs btn-info">
																					<div
																						v-if="formComment.processing && formComment.from_comment_uuid==reply1.comment_uuid"
																						class="spinner-border spinner-border-sm text-white me-1"
																						role="status"
																					>
																						<span class="sr-only">Loading...</span>
																					</div>
																					Comment
																				</button>
																			</div>
																		</div>
																	</form>
																	<div v-if="reply1.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==reply1.comment_uuid && (reply1.to_comment==null || reply1.to_comment.length<=10)" class="text-danger">{{formComment.error_msg}}</div>
												            	</div>
												            </div>
														</div>
													</div>
													<ul v-if="comment.lock_comment==0 && reply1.replies.length>0 && reply1.is_expand==1" class="list ps-3"><!--START 2nd level  -->
														<li v-for="(reply2,r2Index) in reply1.replies" class="list-activity ms-3" :class="{'reply':reply2.lock_comment==0 && reply2.is_expand==1 && reply2.replies.length>0,'last-reply':(reply2.lock_comment==1 && reply1.replies.length==0) || reply1.replies.length==(r2Index+1)}">
															<div class="block mb-2">
																<div class="block-header m-0 p-0 reply-header">
																	<div class="block-title">
																		<span v-if="reply2.is_expand==0" class="me-1">
																			<button @click="reply2.is_expand=1" type="button" class="btn btn-xs btn-outline-secondary rounded-pill show-reply">
																				<i class="fa fa-plus fs-xs"></i>
																			</button>
																		</span>
																		<span v-else class="me-1">
																			<img 
																				class="img-avatar img-avatar20 me-1 user-avatar img-avatar-thumb m-0" :class="{'border border-secondary':reply2.comment_status=='Removed'}"
																				:src="reply2.member_logo"
																			/>
																		</span>
																		<span v-if="reply2.comment_status=='Removed' && reply2.member_uuid!=user.member_uuid" class="text-muted fw-bold fs-xs">[deleted]</span>
																		<inertia-link v-else :href="'/member/community/m/'+reply2.comment_name" class="standard-link fw-semibold fs-xs text-black">{{reply2.comment_name}}</inertia-link> 
																		. <span class="fs-xs text-muted">{{reply2.posted_at}}</span>
																	</div>
																</div>
																<div v-if="reply2.is_expand==1" class="block-content pt-0">
																	<div>
																		<span v-if="(reply2.comment_status=='Removed' || reply2.lock_comment==1 || reply2.is_spam==1) && (community.member_uuid==user.member_uuid || reply2.member_uuid==user.member_uuid)" class="badge bg-danger">
																			{{reply2.comment_status=='Removed' ? 'Deleted' : reply2.lock_comment==1 ? 'Locked' : reply2.is_spam==1 ? 'Spam' : 'Deleted' }}
																		</span>
																		<div class="fs-sm mt-2" :class="{'text-muted':reply2.comment_status=='Removed' || reply2.lock_comment==1 || reply2.is_spam==1}" style="white-space: pre; white-space:break-spaces;" v-html="reply2.comment"></div>
																	</div>
																	<div class="pt-3">
																		<div class="row">
																			<div class="relative col-11">
																				<div v-if="reply2.lock_comment==0">
																					<button v-if="reply2.replies.length>0" @click="reply2.is_expand=0" type="button" class="btn btn-xs btn-outline-secondary rounded-pill hide-reply">
																						<i class="fa fa-minus fs-xs"></i>
																					</button>
																					<span>
																						<span class="me-3">
																		            		<button @click="votePostComment(reply2.comment_uuid,'like',reply2.vote,(cIndex+'-'+r1Index+'-'+r2Index))" :disabled="formVotePostComment.processing && formVotePostComment.comment_uuid==reply2.comment_uuid" type="button" class="btn btn-xs btn-outline-warning rounded-pill" :class="{'active':reply2.vote==1}">
																		            			<div
																									v-if="formVotePostComment.processing && formVotePostComment.comment_uuid==reply2.comment_uuid && formVotePostComment.vote_label=='like'"
																									class="spinner-border spinner-border-sm text-warning"
																									role="status"
																								>
																									<span class="sr-only">Loading...</span>
																								</div>
																								<i v-else class="fa fa-arrow-up"></i>
																		            		</button>
																		            		<span class="px-1">{{reply2.vote_total}}</span>
																		            		<button @click="votePostComment(reply2.comment_uuid,'dislike',reply2.vote,(cIndex+'-'+r1Index+'-'+r2Index))" :disabled="formVotePostComment.processing && formVotePostComment.comment_uuid==reply2.comment_uuid" type="button" class="btn btn-xs btn-outline-danger rounded-pill" :class="{'active':reply2.vote<0}">
																		            			<div
																									v-if="formVotePostComment.processing && formVotePostComment.comment_uuid==reply2.comment_uuid && formVotePostComment.vote_label=='dislike'"
																									class="spinner-border spinner-border-sm text-danger"
																									role="status"
																								>
																									<span class="sr-only">Loading...</span>
																								</div>
																								<i v-else class="fa fa-arrow-down"></i>
																		            		</button>	
																		            	</span>
																		            	<button @click="reply2.is_comment=1" type="button" class="btn rounded-pill btn-xs btn-alt-secondary me-3"><label for="comment-textarea2" class="cursor-pointer"><i class="fa fa-comment me-1"></i>Reply</label></button>
																					</span>
																					<span>
																	            		<span v-if="(comment.comment_status=='Removed' || reply1.comment_status=='Removed' || reply2.comment_status=='Removed') && (reply2.comment_status=='Removed' && user.member_uuid!=reply2.member_uuid)"></span>
																	            		<span v-else>
																	            			<!-- <button v-if="reply2.insight==1" type="button" class="btn rounded-pill btn-xs btn-alt-secondary me-3"><i class="fa fa-chart-bar me-1"></i>Insights</button> -->
																			            	<button type="button" class="btn rounded-pill btn-xs btn-alt-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">...</button>
																			            	<div class="dropdown-menu" :aria-labelledby="'comment_dropdown_'+cIndex+'_'+r1Index+'_'+r2Index" data-popper-placement="bottom-start">
																			            		<div v-if="user.member_uuid==reply2.member_uuid && reply2.comment_status!='Removed'">
																				            		<a v-if="reply2.is_spam==0" type="button" @click="reply2.is_edit=1,reply2.is_comment=1,reply2.to_comment=reply2.comment" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-edit me-1"></i>Edit</a>
																			            			<a type="button" @click="confirmDeletePostComment(reply2.comment_uuid,(cIndex+'-'+r1Index+'-'+r2Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash me-1"></i>Delete</a>
																			            		</div>
																			            		<div v-else>
																			            			<a type="button" @click="reportPostComment(reply2.comment_uuid)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-flag me-1"></i>Report</a>
																			            		</div>
																			            	</div>
																	            		</span>
																	            	</span>
																					<span v-if="reply2.comment_status=='Removed' && community.member_uuid==user.member_uuid" class="ms-3">
																	            		<button type="button" class="btn btn-xs btn-outline-secondary">
																	            			<span>Removed {{reply2.removed_at}}</span>
																	            		</button>
																	            	</span>
																            	</div>
																            </div>
															            	<div v-if="user.member_uuid==community.member_uuid" class="col-1">
															            		<button type="button" :id="'settings_comment_dropdown_'+cIndex+'_'+r1Index+'_'+r2Index" class="btn btn-xs btn-outline-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i class="fa fa-cog"></i></button>
															            		<div class="dropdown-menu" :aria-labelledby="'settings_comment_dropdown_'+cIndex+'_'+r1Index+'_'+r2Index" data-popper-placement="bottom-start">
																            		<a v-if="reply2.comment_status!='Removed' && user.member_uuid!=reply2.member_uuid" type="button" @click="confirmDeletePostComment(reply2.comment_uuid,(cIndex+'-'+r1Index+'-'+r2Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-times me-1"></i>Remove</a>
															            			<a v-if="reply2.is_spam==0 && user.member_uuid!=reply2.member_uuid" type="button" @click="confirmSpamPostComment(reply2.comment_uuid,(cIndex+'-'+r1Index+'-'+r2Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-calendar-times me-1"></i>Mark as Spam</a>
																            		<a type="button" @click="confirmLockUnlockComment(reply2.comment_uuid,reply2.lock_comment,(cIndex+'-'+r1Index+'-'+r2Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa me-1" :class="{'fa-lock':reply2.lock_comment==0,'fa-unlock':reply2.lock_comment==1}"></i>{{reply2.lock_comment==1?'Unlock':'Lock'}} Comment</a>
																            	</div>
															            	</div>
														            	</div>
														            	<div v-if="reply2.is_comment==1" class="my-2">
														            		<form id="commentareaform" class="form-control block block-rounded mb-0" :class="{'border-danger':reply2.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==reply2.comment_uuid && (reply2.to_comment==null || reply2.to_comment.length<=10)}">
															            		<textarea v-model="reply2.to_comment" :readonly="formComment.processing" id="comment-textarea2" name="comment-textarea2" class="comment-textarea" placeholder="Join the conversation"></textarea>
																				<div class="m-1">
																					<div class="text-end">
																						<button @click="reply2.is_comment=0,reply2.to_comment=null" type="button" :disabled="formComment.processing" class="btn btn-xs btn-outline-secondary me-1">Cancel</button>
																						<button @click="postComment(reply2.comment_uuid,3,reply2.to_comment,(cIndex+'-'+r1Index+'-'+r2Index),reply2.is_edit)" type="button" :disabled="formComment.processing" class="btn btn-xs btn-info">
																							<div
																								v-if="formComment.processing && formComment.from_comment_uuid==reply2.comment_uuid"
																								class="spinner-border spinner-border-sm text-white me-1"
																								role="status"
																							>
																								<span class="sr-only">Loading...</span>
																							</div>
																							Comment
																						</button>
																					</div>
																				</div>
																			</form>
																			<div v-if="reply2.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==reply2.comment_uuid && (reply2.to_comment==null || reply2.to_comment.length<=10)" class="text-danger">{{formComment.error_msg}}</div>
														            	</div>
														            </div>
																</div>
															</div>
															<ul v-if="reply2.lock_comment==0 && reply2.replies.length>0 && reply2.is_expand==1" class="list ps-3"><!--START 3rd level  -->
																<li v-for="(reply3,r3Index) in reply2.replies" class="list-activity ms-3" :class="{'last-reply':(reply3.lock_comment==1 && reply2.replies.length==0) || reply2.replies.length==(r3Index+1)}">
																	<div class="block mb-2">
																		<div class="block-header m-0 p-0 reply-header">
																			<div class="block-title">
																				<span v-if="reply3.is_expand==0" class="me-1">
																					<button @click="reply3.is_expand=1" type="button" class="btn btn-xs btn-outline-secondary rounded-pill show-reply">
																						<i class="fa fa-plus xs"></i>
																					</button>
																				</span>
																				<span v-else class="me-1">
																					<img 
																						class="img-avatar img-avatar20 me-1 user-avatar img-avatar-thumb m-0" :class="{'border border-secondary':reply3.comment_status=='Removed'}"
																						:src="reply3.member_logo"
																					/>
																				</span>
																				<span v-if="reply3.comment_status=='Removed' && reply3.member_uuid!=user.member_uuid" class="text-muted fw-bold fs-xs">[deleted]</span>
																				<inertia-link v-else :href="'/member/community/m/'+reply3.comment_name" class="standard-link fw-semibold fs-xs text-black">{{reply3.comment_name}}</inertia-link> 
																				. <span class="fs-xs text-muted">{{reply3.posted_at}}</span>
																			</div>
																		</div>
																		<div v-if="reply3.is_expand==1" class="block-content pt-0">
																			<div>
																				<span v-if="(reply3.comment_status=='Removed' || reply3.lock_comment==1 || reply3.is_spam==1) && (community.member_uuid==user.member_uuid || reply3.member_uuid==user.member_uuid)" class="badge bg-danger">
																					{{reply3.comment_status=='Removed' ? 'Deleted' : reply3.lock_comment==1 ? 'Locked' : reply3.is_spam==1 ? 'Spam' : 'Deleted' }}
																				</span>
																				<div class="fs-sm mt-2" :class="{'text-muted':reply3.comment_status=='Removed' || reply3.lock_comment==1 || reply3.is_spam==1}" style="white-space: pre; white-space:break-spaces;" v-html="reply3.comment"></div>
																			</div>
																			<div class="row pt-3">
																				<div class="col-11">
																					<div v-if="reply3.lock_comment==0">
																						<span>
																			            	<span class="me-3">
																			            		<button @click="votePostComment(reply3.comment_uuid,'like',reply3.vote,(cIndex+'-'+r1Index+'-'+r2Index+'-'+r3Index))" :disabled="formVotePostComment.processing && formVotePostComment.comment_uuid==reply3.comment_uuid" type="button" class="btn btn-xs btn-outline-warning rounded-pill" :class="{'active':reply3.vote==1}">
																			            			<div
																										v-if="formVotePostComment.processing && formVotePostComment.comment_uuid==reply3.comment_uuid && formVotePostComment.vote_label=='like'"
																										class="spinner-border spinner-border-sm text-warning"
																										role="status"
																									>
																										<span class="sr-only">Loading...</span>
																									</div>
																									<i v-else class="fa fa-arrow-up"></i>
																			            		</button>
																			            		<span class="px-1">{{reply3.vote_total}}</span>
																			            		<button @click="votePostComment(reply3.comment_uuid,'dislike',reply3.vote,(cIndex+'-'+r1Index+'-'+r2Index+'-'+r3Index))" :disabled="formVotePostComment.processing && formVotePostComment.comment_uuid==reply3.comment_uuid" type="button" class="btn btn-xs btn-outline-danger rounded-pill" :class="{'active':reply3.vote<0}">
																			            			<div
																										v-if="formVotePostComment.processing && formVotePostComment.comment_uuid==reply3.comment_uuid && formVotePostComment.vote_label=='dislike'"
																										class="spinner-border spinner-border-sm text-danger"
																										role="status"
																									>
																										<span class="sr-only">Loading...</span>
																									</div>
																									<i v-else class="fa fa-arrow-down"></i>
																			            		</button>	
																			            	</span>
																			            </span>
																			            <span>
																		            		<span v-if="(comment.comment_status=='Removed' || reply1.comment_status=='Removed' || reply2.comment_status=='Removed' || reply3.comment_status=='Removed') && (reply3.comment_status=='Removed' && user.member_uuid!=reply3.member_uuid)"></span>
																		            		<span v-else>
																		            			<!-- <button v-if="reply2.insight==1" type="button" class="btn rounded-pill btn-xs btn-alt-secondary me-3"><i class="fa fa-chart-bar me-1"></i>Insights</button> -->
																				            	<button type="button" class="btn rounded-pill btn-xs btn-alt-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">...</button>
																				            	<div class="dropdown-menu" :aria-labelledby="'comment_dropdown_'+cIndex+'_'+r1Index+'_'+r2Index+'_'+r3Index" data-popper-placement="bottom-start">
																				            		<div v-if="user.member_uuid==reply3.member_uuid && reply3.comment_status!='Removed'">
																					            		<a v-if="reply3.is_spam==0" type="button" @click="reply3.is_edit=1,reply3.is_comment=1,reply3.to_comment=reply3.comment" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-edit me-1"></i>Edit</a>
																					            		<a type="button" @click="confirmDeletePostComment(reply3.comment_uuid,(cIndex+'-'+r1Index+'-'+r2Index+'-'+r3Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash me-1"></i>Delete</a>
																				            		</div>
																				            		<div v-else>
																				            			<a type="button" @click="reportPostComment(comment.comment_uuid)" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-flag me-1"></i>Report</a>
																				            		</div>
																				            	</div>
																		            		</span>
																		            	</span>
																		            	<span v-if="reply3.comment_status=='Removed' && community.member_uuid==user.member_uuid" class="ms-3">
																		            		<button type="button" class="btn btn-xs btn-outline-secondary">
																		            			<span>Removed {{reply3.removed_at}}</span>
																		            		</button>
																		            	</span>
																		           </div>
																	           </div>
																	            <div v-if="user.member_uuid==community.member_uuid" class="col-1">
																            		<button type="button" :id="'settings_comment_dropdown_'+cIndex+'_'+r1Index+'_'+r2Index+'_'+r3Index" class="btn btn-xs btn-outline-secondary px-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true"><i class="fa fa-cog"></i></button>
																            		<div class="dropdown-menu" :aria-labelledby="'settings_comment_dropdown_'+cIndex+'_'+r1Index+'_'+r2Index+'_'+r3Index" data-popper-placement="bottom-start">
																	            		<a v-if="reply3.comment_status!='Removed' && user.member_uuid!=reply3.member_uuid" type="button" @click="confirmDeletePostComment(reply3.comment_uuid,(cIndex+'-'+r1Index+'-'+r2Index+'-'+r3Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-times me-1"></i>Remove</a>
																            			<a v-if="reply3.is_spam==0 && user.member_uuid!=reply3.member_uuid" type="button" @click="confirmSpamPostComment(reply3.comment_uuid,(cIndex+'-'+r1Index+'-'+r2Index+'-'+r3Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa fa-calendar-times me-1"></i>Mark as Spam</a>
																	            		<a type="button" @click="confirmLockUnlockComment(reply3.comment_uuid,reply3.lock_comment,(cIndex+'-'+r1Index+'-'+r2Index+'-'+r3Index))" class="dropdown-item" href="javascript:void(0)"><i class="fa me-1" :class="{'fa-lock':reply3.lock_comment==0,'fa-unlock':reply3.lock_comment==1}"></i>{{reply3.lock_comment==1?'Unlock':'Lock'}} Comment</a>
																	            	</div>
																            	</div>
																            </div>
																            <div v-if="reply3.is_comment==1" class="my-2">
															            		<form id="commentareaform" class="form-control block block-rounded mb-0" :class="{'border-danger':reply3.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==reply3.comment_uuid && (reply3.to_comment==null || reply3.to_comment.length<=10)}">
																            		<textarea v-model="reply3.to_comment" :readonly="formComment.processing" id="comment-textarea2" name="comment-textarea2" class="comment-textarea" placeholder="Join the conversation"></textarea>
																					<div class="m-1">
																						<div class="text-end">
																							<button @click="reply3.is_comment=0,reply3.to_comment=null" type="button" :disabled="formComment.processing" class="btn btn-xs btn-outline-secondary me-1">Cancel</button>
																							<button @click="postComment(reply3.comment_uuid,3,reply3.to_comment,(cIndex+'-'+r1Index+'-'+r2Index+'-'+r3Index),1)" type="button" :disabled="formComment.processing" class="btn btn-xs btn-info">
																								<div
																									v-if="formComment.processing && formComment.from_comment_uuid==reply3.comment_uuid"
																									class="spinner-border spinner-border-sm text-white me-1"
																									role="status"
																								>
																									<span class="sr-only">Loading...</span>
																								</div>
																								Comment
																							</button>
																						</div>
																					</div>
																				</form>
																				<div v-if="reply3.is_comment==1 && formComment.is_error && formComment.from_comment_uuid==reply3.comment_uuid && (reply3.to_comment==null || reply3.to_comment.length<=10)" class="text-danger">{{formComment.error_msg}}</div>
															            	</div>
																		</div>
																	</div>
																</li>
															</ul>
														</li>
													</ul>
												</li>
											</ul>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<Error :error="500"/>
					</div>
				</div>
			</div>

			<div v-if="community!==null" class="col-lg-4 mb-6 d-none d-sm-table-cell">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="fw-bold mb-2">{{community.community_name}}</div>
						<div class="fs-xs mb-1"><i class="fa fa-calendar me-1"></i>Created {{community.posted_at}}</div>
						<div class="fs-xs mb-1"><i class="fa me-1" :class="{'fa-globe':community.status=='Public','fa-eye':community.status=='Restricted','fa-lock':community.status=='Private'}"></i>{{community.status}}</div>
					</div>
					<div class="block-content block-content-full border-top border-1">
						<div class="row">
							<div class="col">
								<div class="text-info fw-bold">{{community.member_total}}</div>
								<span class="fs-xs">Member</span>
							</div>
							<div class="col">
								<div class="text-info fw-bold">{{community.member_total}}</div>
								<span class="fs-xs">Online</span>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<div v-else>
			<Error :error='404'/>
		</div>
	</div>
</template>

<script>
	
import { watch, onMounted, ref } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import ContentSlot from './ContentSlot';
import { createToaster } from '@meforma/vue-toaster'
import { useForm, usePage } from '@inertiajs/inertia-vue3'

export default {
	props:{
		flash 				: Object,
		errors 				: Object,
		user 				: Object,
		community 			: Object,
		post 				: Object,
		comments 			: Object,
		comment_info 		: Object,
	},
	layout: AuthLayout,
	setup(props) {

		const toast = createToaster();

		const contentSlot 						= ref(null);
		const reportModal 						= ref(null);
		const confirmDeletePostModal 			= ref(null);
		const confirmDeletePostCommentModal 	= ref(null);
		const confirmRemovePostCommentModal 	= ref(null);
		const confirmSpamPostCommentModal 		= ref(null);
		const confirmLockUnlockPostModal 		= ref(null);
		const confirmLockUnlockPostCommentModal = ref(null);
		const confirmLockUnlockCommentModal 	= ref(null);
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
			
		})

		const formRequestToJoin = useForm({
			processing : false
		});

		const formPost = useForm({
			title 			: null,
			lock_post 		: 0,
			lock_comment 	: 0,
			cache 			: 'post_comments',
			is_error 		: false,
			error_msg 		: "Field is required or Minimum of 10 character length is required.",
		});

		const formComment = useForm({
			community_uuid 		: props.community.community_uuid,
			community_status 	: props.community.status,
			join_status 		: props.community.join_status,
			post_uuid 			: null,
			from_comment_uuid 	: null,
			comment 			: null,
			comment_level 		: 0,
			lock_comment 		: 0,
			comment_status 		: null,
			indexes 			: null,
			is_error 			: false,
			error_msg 			: "Field is required or Minimum of 10 character length is required.",
		});

		const formVotePostComment = useForm({
			post_uuid 			: null,
			comment_uuid 		: null,
			vote_label 			: '',
			prev_vote 			: 0,
			vote 				: 0,
			reply_indexes 		: null
		});

		const formJoinCommunity = useForm({
			community_uuid 	: props.community.community_uuid,
			community_name 	: props.community.community_name,
			community_status: props.community.status,
			processing  	: false
		});

		const formReport = useForm({
			community_uuid 	: null,
			report_type 	: null,
		});

		const joinCommunity = ()=>{
			
			formJoinCommunity.processing 		= true;

			contentSlot.value.joinCommunity(formJoinCommunity,(res)=>{
				if(res)
				{
					formJoinCommunity.reset();
				}
			});
		}


		const updatePost = ()=>{

			formPost.is_error = false;

			if(formPost.title==null)
			{
				formPost.is_error = true;
				return false;
			}
			if(formPost.title.length<=10)
			{
				formPost.is_error = true;
				return false;
			}

			formPost.put(route('member.community.post-update',{post_uuid:props.post.post_uuid}), {
						preserveState: true,
						preserveScroll: true,
						only: ['flash','errors'],
						onSuccess:()=>{
							if(props.flash.toast.type=="success"){

								props.post.title 	= formPost.title;
								props.post.is_edit 	= 0;

								formPost.reset();

							}
						}
					})

		}

		const confirmDeletePost = ()=>{

			confirmDeletePostModal.value.toggleModal();

		}

		const deletePost = ()=>{

			formPost.delete(route('member.community.post-delete',{post_uuid:props.post.post_uuid}), {
						preserveState: true,
						preserveScroll: true,
						only: ['flash','errors','post'],
						onSuccess:()=>{
							if(props.flash.toast.type=="success"){

								confirmDeletePostModal.value.toggleModal();

								formPost.reset();
							}
						}
					})

		}


		const postComment = (_pcuuid,_level,_tocomment,_indexes,_edit)=>{

			formComment.post_uuid 			= props.post.post_uuid;
			formComment.from_comment_uuid 	= _pcuuid;
			formComment.comment_level 		= _level;
			formComment.comment 			= _tocomment;
			formComment.is_error 			= false;

			if(_edit==1)
			{
				updatePostComment(_pcuuid,_level,_tocomment,_indexes);
				return false;
			}

			if(formComment.comment==null)
			{
				formComment.is_error = true;
				return false;
			}
			if(formComment.comment.length<=10)
			{
				formComment.is_error = true;
				return false;
			}

			formComment.post(route('member.community.comment-store',{post_uuid:formComment.post_uuid}), {
						preserveState: true,
						preserveScroll: true,
						only: ['flash','errors','comment_info'],
						onSuccess:()=>{
							if(props.flash.toast.type=="success"){
								formComment.reset();

								let comment_total = 0;

								comment_total = props.comment_info.comment_total;

								delete props.comment_info.comment_total;

								props.post.comment_total = comment_total;

								if(_indexes!==undefined)
								{
									let rep_indexes =[];
									if(typeof _indexes === 'string')
									{
										let r1 = 0, r2 = 0, r3 = 0;

										rep_indexes.push(_indexes.split('-'));
										rep_indexes = rep_indexes[0];
										
										if(rep_indexes.length==2){

											r1 = parseInt(rep_indexes[0]);
											r2 = parseInt(rep_indexes[1]);

											props.comments[r1].replies[r2].is_comment = 0;
											props.comments[r1].replies[r2].to_comment = "";
											props.comments[r1].replies[r2].replies.unshift(props.comment_info);

										}else if(rep_indexes.length==3){

											r1 = parseInt(rep_indexes[0]);
											r2 = parseInt(rep_indexes[1]);
											r3 = parseInt(rep_indexes[2]);

											props.comments[r1].replies[r2].replies[r3].is_comment = 0;
											props.comments[r1].replies[r2].replies[r3].to_comment = "";
											props.comments[r1].replies[r2].replies[r3].replies.unshift(props.comment_info);

										}

									}else{
										
										props.comments[_indexes].is_comment = 0;
										props.comments[_indexes].to_comment = "";
										props.comments[_indexes].replies.unshift(props.comment_info);
									}
									
								}else{
									props.post.is_comment = 0;
									props.post.to_comment = "";

									if(props.comment_info!=null)
									{
										props.comments.unshift(props.comment_info);
									}

								}
							}
						}
					})

		}

		const updatePostComment = (_cuuid,_level,_tocomment,_indexes)=>{

			formComment.put(route('member.community.comment-update',{post_uuid:formComment.post_uuid,comment_uuid:_cuuid}), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','errors'],
							onSuccess:()=>{
								if(props.flash.toast.type=="success"){

									if(_indexes!==undefined)
									{
										let rep_indexes =[];
										if(typeof _indexes === 'string')
										{
											let r1 = 0, r2 = 0, r3 = 0, r4 = 0;

											rep_indexes.push(_indexes.split('-'));
											rep_indexes = rep_indexes[0];
											
											if(rep_indexes.length==2){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);

												props.comments[r1].replies[r2].is_edit 		= 0;
												props.comments[r1].replies[r2].is_comment 	= 0;
												props.comments[r1].replies[r2].to_comment 	= "";
												props.comments[r1].replies[r2].comment 		= formComment.comment;

											}else if(rep_indexes.length==3){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);

												props.comments[r1].replies[r2].replies[r3].is_edit 		= 0;
												props.comments[r1].replies[r2].replies[r3].is_comment 	= 0;
												props.comments[r1].replies[r2].replies[r3].to_comment 	= "";
												props.comments[r1].replies[r2].replies[r3].comment 		= formComment.comment;

											}else if(rep_indexes.length==4){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);
												r4 = parseInt(rep_indexes[3]);

												props.comments[r1].replies[r2].replies[r3].replies[r4].is_edit 		= 0;
												props.comments[r1].replies[r2].replies[r3].replies[r4].is_comment 	= 0;
												props.comments[r1].replies[r2].replies[r3].replies[r4].to_comment 	= "";
												props.comments[r1].replies[r2].replies[r3].replies[r4].comment 		= formComment.comment;

											}

										}else{
											
											props.comments[_indexes].is_edit 	= 0;
											props.comments[_indexes].is_comment = 0;
											props.comments[_indexes].to_comment = "";
											props.comments[_indexes].comment 	= formComment.comment;
										}
										
									}else{
										props.post.is_edit 		= 0;
										props.post.is_comment 	= 0;
										props.post.to_comment 	= "";
										props.post.comment 		= formComment.comment;

									}

									formComment.reset();
								}
							}
						})

		}

		const confirmRemovePostComment = (_cuuid,_indexes)=>{

			formComment.comment_uuid 	= _cuuid;
			formComment.indexes 		= _indexes;

			formComment.comment_status 	= "Removed";

			confirmDeletePostCommentModal.value.toggleModal();

		}


		const confirmDeletePostComment = (_cuuid,_indexes)=>{

			formComment.comment_uuid 	= _cuuid;
			formComment.indexes 		= _indexes;

			confirmDeletePostCommentModal.value.toggleModal();

		}


		const deletePostComment = ()=>{

			formComment.post_uuid 		= props.post.post_uuid;

			formComment.delete(route('member.community.comment-delete',{post_uuid:formComment.post_uuid,comment_uuid:formComment.comment_uuid}), {
						preserveState: true,
						preserveScroll: true,
						only: ['flash','errors','comment_info'],
						onSuccess:()=>{
							if(props.flash.toast.type=="success"){
								let _indexes = formComment.indexes;
								let del_data = props.flash.toast.data;

								confirmDeletePostCommentModal.value.toggleModal();

								props.post.comment_total = props.comment_info.comment_total;

								if(del_data.soft_delete==0)
								{

									if(_indexes!=null && _indexes!=undefined)
									{
										
										let rep_indexes =[];
										
										if(typeof _indexes === 'string')
										{
											let r1 = 0, r2 = 0, r3 = 0, r4 = 0;
											let itemReplies = [];

											rep_indexes.push(_indexes.split('-'));
											rep_indexes = rep_indexes[0];
											
											if(rep_indexes.length==2){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);

												props.comments[r1].replies.splice(r2,1);

											}else if(rep_indexes.length==3){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);

												props.comments[r1].replies[r2].replies.splice(r3,1);

											}else if(rep_indexes.length==4){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);
												r4 = parseInt(rep_indexes[3]);

												props.comments[r1].replies[r2].replies[r3].replies.splice(r4,1);
											}

										}else{
											props.comments.splice(_indexes,1);
										}

									}

								}else{

									if(_indexes!=null && _indexes!=undefined)
									{
										
										let rep_indexes =[];
										
										if(typeof _indexes === 'string')
										{
											let r1 = 0, r2 = 0, r3 = 0, r4 = 0;
											let itemReplies = [];

											rep_indexes.push(_indexes.split('-'));
											rep_indexes = rep_indexes[0];
											
											if(rep_indexes.length==2){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);

												props.comments[r1].replies[r2].comment_status 	= del_data.comment_status;
												props.comments[r1].replies[r2].removed_at 		= del_data.removed_at;

											}else if(rep_indexes.length==3){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);

												props.comments[r1].replies[r2].replies[r3].comment_status 	= del_data.comment_status;
												props.comments[r1].replies[r2].replies[r3].removed_at 		= del_data.removed_at;

											}else if(rep_indexes.length==4){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);
												r4 = parseInt(rep_indexes[3]);

												props.comments[r1].replies[r2].replies[r3].replies[r4].comment_status 	= del_data.comment_status;
												props.comments[r1].replies[r2].replies[r3].replies[r4].removed_at 		= del_data.removed_at;
											}

										}else{
											props.comments[_indexes].comment_status 	= del_data.comment_status;
											props.comments[_indexes].removed_at 		= del_data.removed_at;
										}

									}

								}
								

								formComment.reset();
							}
						}
					})

		}


		const votePostComment = (_pcuuid,_vote,_val,_indexes)=>{
			let retrieve_data = [];
			let reply_indexes = [];
			
			formVotePostComment.post_uuid 			= props.post.post_uuid;
			formVotePostComment.comment_uuid 		= _pcuuid;
			formVotePostComment.vote_label 			= _vote;
			formVotePostComment.prev_vote 			= _val;
			
			if(_indexes!==undefined)
			{
				if(typeof _indexes === 'string')
				{
					reply_indexes.push(_indexes.split('-'));
				}else{
					reply_indexes.push(_indexes);
				}
				formVotePostComment.reply_indexes = reply_indexes;
			}

			if(_vote=='like')
			{
				formVotePostComment.vote 		= 1;
			}else{
				formVotePostComment.vote 		= -1;
			}
			
			if((_val==1 && _vote=='like') || (_val==-1 && _vote=='dislike'))
			{
				formVotePostComment.vote 		= 0;
			}

			if(_pcuuid!=null){
				retrieve_data.push('comments');
			}else{
				retrieve_data.push('post');
			}

			formVotePostComment.post(route('member.community.comment-vote',{post_uuid:formVotePostComment.post_uuid}), {
									preserveState: true,
									preserveScroll: true,
									only: ['flash','errors',retrieve_data],
									onSuccess:()=>{
										if(props.flash.toast.type=="success"){
											formVotePostComment.reset();
										}
									}
								})

		}

		const reportPostComment = (_cuuid)=>{
			formReport.comment_uuid = _cuuid;
			reportModal.value.toggleModal();
		}

		const reportProcess = ()=>{

			formReport.post(route('member.community.comment-vote',{post_uuid:formReport.post_uuid}), {
									preserveState: true,
									preserveScroll: true,
									only: ['flash','errors',retrieve_data],
									onSuccess:()=>{
										if(props.flash.toast.type=="success"){
											formReport.reset();
										}
									}
								})
		}


		const confirmSpamPostComment = (_cuuid,_val,_indexes)=>{
			formComment.comment_uuid 	= _cuuid;
			formComment.indexes  		= _indexes;

			confirmSpamPostCommentModal.value.toggleModal();
		}


		const spamPostComment = ()=>{

			formComment.put(route('member.community.comment-spam',{post_uuid:props.post.post_uuid,comment_uuid:formComment.comment_uuid}), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','errors'],
							onSuccess:()=>{
								if(props.flash.toast.type=="success"){
									let spam_message 	= props.flash.toast.data.spam_message;
									let _indexes 		= formComment.indexes;

									confirmSpamPostCommentModal.value.toggleModal();

									if(_indexes!==null)
									{
										let rep_indexes =[];
										if(typeof _indexes === 'string')
										{
											let r1 = 0, r2 = 0, r3 = 0, r4 = 0;

											rep_indexes.push(_indexes.split('-'));
											rep_indexes = rep_indexes[0];
											
											if(rep_indexes.length==2){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);

												props.comments[r1].replies[r2].is_spam = 1;
												props.comments[r1].replies[r2].spam_message = spam_message;

											}else if(rep_indexes.length==3){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);

												props.comments[r1].replies[r2].replies[r3].is_spam 		= 1;
												props.comments[r1].replies[r2].replies[r3].spam_message = spam_message;

											}else if(rep_indexes.length==4){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);
												r4 = parseInt(rep_indexes[3]);

												props.comments[r1].replies[r2].replies[r3].replies[r4].is_spam 		= 1;
												props.comments[r1].replies[r2].replies[r3].replies[r4].spam_message = spam_message;

											}

										}else{
											props.comments[_indexes].is_spam = 1;
											props.comments[_indexes].spam_message = spam_message;
										}

									}

									formComment.reset();
								}
							}
						})

		}

		const confirmLockUnlockPost = (_val)=>{
			formPost.lock_post 	= (_val==1 ? 0 : 1);

			confirmLockUnlockPostModal.value.toggleModal();
		}


		const lockUnlockPost = ()=>{

			formPost.put(route('member.community.post-lock_unlock',{post_uuid:props.post.post_uuid}), {
						preserveState: true,
						preserveScroll: true,
						only: ['flash','errors'],
						onSuccess:()=>{
							if(props.flash.toast.type=="success"){
								
								confirmLockUnlockPostModal.value.toggleModal();

								props.post.lock_post = formPost.lock_post;

								formPost.reset();
							}
						}
					})

		}


		const confirmLockUnlockPostComment = (_val)=>{
			formPost.lock_comment 	= (_val==1 ? 0 : 1);

			confirmLockUnlockPostCommentModal.value.toggleModal();
		}


		const lockUnlockPostComment = ()=>{

			formPost.put(route('member.community.post-comment-lock_unlock',{post_uuid:props.post.post_uuid}), {
						preserveState: true,
						preserveScroll: true,
						only: ['flash','errors'],
						onSuccess:()=>{
							if(props.flash.toast.type=="success"){

								confirmLockUnlockPostCommentModal.value.toggleModal();
								
								props.post.lock_comment = formPost.lock_comment;

								formPost.reset();
							}
						}
					})

		}


		const confirmLockUnlockComment = (_cuuid,_val,_indexes)=>{
			formComment.comment_uuid 	= _cuuid;
			formComment.indexes  		= _indexes;
			formComment.lock_comment 	= (_val==1 ? 0 : 1);

			confirmLockUnlockCommentModal.value.toggleModal();
		}


		const lockUnlockComment = ()=>{

			formComment.put(route('member.community.comment-lock_unlock',{post_uuid:props.post.post_uuid,comment_uuid:formComment.comment_uuid}), {
							preserveState: true,
							preserveScroll: true,
							only: ['flash','errors'],
							onSuccess:()=>{
								if(props.flash.toast.type=="success"){
									let lock_message 	= props.flash.toast.data.lock_message;
									let _indexes 		= formComment.indexes;

									confirmLockUnlockCommentModal.value.toggleModal();

									if(_indexes!==null)
									{
										let rep_indexes =[];
										if(typeof _indexes === 'string')
										{
											let r1 = 0, r2 = 0, r3 = 0, r4 = 0;

											rep_indexes.push(_indexes.split('-'));
											rep_indexes = rep_indexes[0];
											
											if(rep_indexes.length==2){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);

												props.comments[r1].replies[r2].lock_comment = formComment.lock_comment;
												props.comments[r1].replies[r2].lock_message = lock_message;

											}else if(rep_indexes.length==3){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);

												props.comments[r1].replies[r2].replies[r3].lock_comment = formComment.lock_comment;
												props.comments[r1].replies[r2].replies[r3].lock_message = lock_message;

											}else if(rep_indexes.length==4){

												r1 = parseInt(rep_indexes[0]);
												r2 = parseInt(rep_indexes[1]);
												r3 = parseInt(rep_indexes[2]);
												r4 = parseInt(rep_indexes[3]);

												props.comments[r1].replies[r2].replies[r3].replies[r4].lock_comment = formComment.lock_comment;
												props.comments[r1].replies[r2].replies[r3].replies[r4].lock_message = lock_message;

											}

										}else{
											props.comments[_indexes].lock_comment = formComment.lock_comment;
											props.comments[_indexes].lock_message = lock_message;
										}

									}

									formComment.reset();
								}
							}
						})

		}


		return{
			contentSlot,
			reportModal,
			confirmDeletePostModal,
			confirmDeletePostCommentModal,
			confirmRemovePostCommentModal,
			confirmSpamPostCommentModal,
			confirmLockUnlockPostModal,
			confirmLockUnlockPostCommentModal,
			confirmLockUnlockCommentModal,
			formPost,
			formComment,
			formVotePostComment,
			formJoinCommunity,
			formReport,
			joinCommunity,
			updatePost,
			postComment,
			updatePostComment,
			votePostComment,
			deletePost,
			confirmDeletePost,
			confirmDeletePostComment,
			confirmRemovePostComment,
			deletePostComment,
			reportPostComment,
			reportProcess,
			confirmSpamPostComment,
			spamPostComment,
			confirmLockUnlockPost,
			confirmLockUnlockPostComment,
			confirmLockUnlockComment,
			lockUnlockPost,
			lockUnlockPostComment,
			lockUnlockComment,
		}

	},
}
</script>
